module.exports = __webpack_public_path__ + "2f1a3c856ba1ec4ba1e64ba59cab2781.svg";